import { useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import {
  ToggleButton,
  ToggleContent,
  ToggleButtonGroup,
} from '@/components/shared/toggle-button-group';
import { useNavigate } from 'react-router';
import { ContentBox } from '@/components/shared/content-box';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { useNotification } from '@/context/notification';
import { useCreatePlan } from '@/data/idp/plans';
import { useCreateProfileBasedRecommendation } from '@/data/idp/profile-based-recommendations';
import { RecommendationPlanIds } from '@/data/idp/profile-based-recommendations/interfaces';

export const RecommendationType = () => {
  const navigate = useNavigate();
  const {
    mutate: createProfileBasedRecommendation,
    isPending: isCreatingProfileBasedRecommendation,
  } = useCreateProfileBasedRecommendation();
  const { mutate: createPlan, isPending: isCreatingPlan } = useCreatePlan();
  const [type, setType] = useState('');
  const [error, setError] = useState('');
  const { toast } = useNotification();

  const isPending = isCreatingProfileBasedRecommendation || isCreatingPlan;

  const handleCreateRecommendedPlan = () => {
    createProfileBasedRecommendation(RecommendationPlanIds.Duration, {
      onSuccess: (response) => {
        const planId = response.plan.id;
        navigate(`/pdi/planos/novo/${planId}`);
      },
      onError: () => {
        toast({
          content: 'Erro ao criar plano recomendado por IA.',
          type: 'error',
        });
      },
    });
  };

  const handleCreatePlan = () => {
    createPlan(
      { title: '' },
      {
        onSuccess: (response) => {
          const planId = response.id;
          navigate(`/pdi/planos/${planId}`);
          toast({
            content: 'Plano criado com sucesso.',
            type: 'success',
          });
        },
        onError: () => {
          toast({
            content: 'Erro ao criar plano.',
            type: 'error',
          });
        },
      }
    );
  };

  const handleContinue = () => {
    if (!type) {
      setError('Selecione uma opção para continuar.');
      return;
    }

    if (type === 'recommended') {
      handleCreateRecommendedPlan();
      return;
    }

    handleCreatePlan();
  };

  return (
    <PageContainer>
      <PageHeader
        backNavigationText="Voltar"
        handleBackNavigation={() => navigate('/pdi/planos')}
      />
      <ContentBox>
        <Typography variant="h2" mb={3}>
          Como você gostaria de criar seu plano?
        </Typography>
        <ToggleButtonGroup
          onChange={setType}
          value={type}
          direction={{ md: 'row' }}
        >
          <ToggleButton value="recommended">
            <ToggleContent
              title="Recomendado por Inteligência Artificial"
              icon="robot-happy"
              description="Defina seus objetivos e deixe nossa IA criar um Plano Personalizado para você. Após a recomendação, você pode ajustar e personalizar o plano como desejar."
            />
          </ToggleButton>
          <ToggleButton value="not-recommended">
            <ToggleContent
              title="Sem Recomendação"
              icon="activity"
              description="Crie seu plano manualmente, sem a ajuda da IA."
            />
          </ToggleButton>
        </ToggleButtonGroup>
        {error && (
          <Alert severity="error" sx={{ mt: 3 }}>
            {error}
          </Alert>
        )}
        <Stack direction="row" justifyContent="flex-end" mt={3}>
          <Button
            onClick={handleContinue}
            variant="contained"
            loading={isPending}
          >
            Continuar
          </Button>
        </Stack>
      </ContentBox>
    </PageContainer>
  );
};
